export const checkoutInitRoute = {
  path: '/checkout-widget-init',
  component: 'cw-init',
  componentName: 'Checkout Widget Init',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const checkEligibilityRoute = {
  path: '/checkout-widget-check-eligibility',
  component: 'cw-check-eligibility',
  componentName: 'Check Eligibility',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const selectLenderRoute = {
  path: '/checkout-widget-select-lender',
  component: 'cw-select-lender',
  componentName: 'Select Lender',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const nonApprovedRoute = {
  path: '/checkout-widget-non-approved',
  component: 'cw-non-approved',
  componentName: 'Non Approved',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const checkoutNtbRoute = {
  path: '/checkout-widget-ntb',
  component: 'cw-ntb',
  componentName: 'NTB',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const selectEmiPlanRoute = {
  path: '/checkout-widget-select-emi-plan',
  component: 'cw-select-emi-plan',
  componentName: 'Select Emi Plan',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const aivfRoute = {
  path: '/checkout-widget-aivf',
  component: 'cw-aivf',
  componentName: 'AIVF',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const transactionVerifyOtpRoute = {
  path: '/checkout-widget-transaction-verify-otp',
  component: 'cw-transaction-verify-otp',
  componentName: 'Transaction Verify OTP',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const paymentSuccess = {
  path: '/checkout-widget-payment-success',
  component: 'cw-payment-success',
  componentName: 'Payment Success',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const paymentFailure = {
  path: '/checkout-widget-payment-failure',
  component: 'cw-payment-failure',
  componentName: 'Payment failure',
  theme: 'instaCred',
  template: 'checkoutWidget',
};

export const checkoutWidgetRoutes = [
  checkoutInitRoute,
  checkEligibilityRoute,
  selectLenderRoute,
  nonApprovedRoute,
  checkoutNtbRoute,
  selectEmiPlanRoute,
  aivfRoute,
  transactionVerifyOtpRoute,
  paymentSuccess,
  paymentFailure,
];



// WEBPACK FOOTER //
// ./alias/checkoutWidgetRoutes.js